import { AnalyticsEvent, logAnalyticsEvent } from 'utils/analytics'
import { FC, useEffect } from 'react'
import { usePurchaseFlowConfig, usePurchaseFlowProducts } from '../../_main/contexts'

import { Fade } from '@mui/material'
import { MeasurementStepRedesignController } from './MeasurementStepRedesign.controller'
import Stack from '@mui/material/Stack'
import { StepWrapper } from '../../common/StepWrapper'
import { SystemMessage } from 'components/common/SystemMessage'
import { useTranslation } from 'react-i18next'

/**
 * Controller for the Measurement requirements step in the Purchase Flow.
 *
 * @example
 * <MeasurementStepController />
 */
export const MeasurementStepController: FC = () => {
  const { t } = useTranslation(['purchase_flow'], { keyPrefix: 'measurement_step' })
  const { selectedCategory } = usePurchaseFlowConfig()
  const {
    selectedKinds,
    selectedProductTypes,
    selectedProducts,
  } = usePurchaseFlowProducts()

  useEffect(() => {
    logAnalyticsEvent(AnalyticsEvent.ENTER_ORDER_MEASUREMENTS_PAGE_SCREEN, {
      productTypes: Array.from(selectedProductTypes),
      productKinds: Array.from(selectedKinds),
      products: Object.values(selectedProducts),
      category: selectedCategory,
    })

    // Only trigger when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <StepWrapper
      title={t('section_title')}
      subtitle={t('section_description')}
    >
      <Fade in={true}>
        <Stack gap={2} width="100%" display="flex" justifyContent="space-between">

          <SystemMessage variant="system" message={t('estimate_disclaimer')} />

          {/* Property-type cards, per-unit floors, cellar scope (ISSUE-2187) */}
          <MeasurementStepRedesignController />

        </Stack>
      </Fade>
    </StepWrapper>
  )
}
